module.exports = __webpack_public_path__ + "img/app-store.eb219ea.svg";